import { createSelector } from 'reselect'
import configurationDataSelector from './configurationDataSelector'

const hasModelConflictSelector = createSelector(
    configurationDataSelector,
    (configurationData): boolean => configurationData.configurationState === 'MODEL_CONFLICT',
)

export default hasModelConflictSelector
